export const useLocalStorageService = () => {
  const getItem = (key: string) => {
    if (localStorage) {
      return localStorage.getItem(key)
    } else {
      console.error('Browser does not support localStorage')
    }
  }

  const setItem = (key: string, value: any) => {
    if (localStorage) {
      localStorage.setItem(key, value)
    } else {
      console.error('Browser does not support localStorage')
    }
  }

  return {
    getItem,
    setItem
  }
}
